import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import BaseBooleanInput, { IBaseBooleanInputProps } from '@gik/ui/BaseBooleanInput/BaseBooleanInput';
import { UISwitchVariant } from '@gik/ui/types';

export interface ISwitchProps extends IBaseBooleanInputProps {
  /**
   * Style variant to use
   */
  variant?: UISwitchVariant;
}

const blockName = `switch`;

function Switch(
  { variant = 'default', size = 'base', ...otherProps }: ISwitchProps,
  ref: React.LegacyRef<HTMLInputElement>
) {
  const bem = bemBlock(blockName);

  const props = {
    variant,
    size,
    indeterminate: false,
    ...otherProps,
  };

  return (
    <BaseBooleanInput
      {...props}
      bem={bem}
      render={({ indeterminate: _, ...inputProps }) => (
        <div className={bem(`wrapper`)}>
          <input ref={ref as React.LegacyRef<HTMLInputElement>} {...inputProps} />
          <div className={bem(`handle`)} />
        </div>
      )}
    />
  );
}

export default React.forwardRef(Switch);

export const SwitchNoRef = Switch;
